import { render } from "./loginComponent.vue?vue&type=template&id=0d4b4e4e"
import script from "./loginComponent.vue?vue&type=script&lang=js"
export * from "./loginComponent.vue?vue&type=script&lang=js"

import "./loginComponent.vue?vue&type=style&index=0&id=0d4b4e4e&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__